<template>
  <span class="edinput-container card-toolbar my-0">
    <label v-show="!edit" ref="popLabel" @click="mkEditable"
           @mouseover="mkHovered"
           class="w-100 edinput-label cursor-pointer  d-inline-flex flex-wrap gap-1"
    >
      <span class="edinput-edit rounded border border-1"> <i class="fa fa-pencil-alt"></i></span>
<!--      &nbsp;-->
      <slot name="label">
        <div v-if="type === 'check'">
          <span v-if="label">{{ label }}</span>
          <span v-else><yes-no :ans="value"/></span>
        </div>
        <div v-else-if="type === 'user_select'">
          <div v-for="v in value">{{ v.email }}</div>
        </div>
        <div v-else-if="type === 'select' && conf.multiple">
          <span v-for="v in label" class="pending">{{ v.name }}</span>
        </div>
        <span class="" v-else>{{ label ? label : value }}</span>
      </slot>
    </label>
    <!--         :class="[absClasses, {'edit-left': position == 'left', 'edit-far-left': position == 'far-left', 'edit-top': vertPosition == 'top'}]"-->
    <!--         style="width: 200px"-->
    <!--    v-show="edit"-->
    <div v-if="editable && hovered" ref="popContent" class="">
      <div v-show="edit" class="menu-item edinput-input">
        <select2
            ref="selector"
            v-if="type==='select' && config"
            :value="value"
            @change="emitSelectValue"
            :options="options"
            :config="config"
        />
        <!--        <treeselect-->
        <!--            v-if="type==='select'"-->
        <!--            class="fw-bold mb-1"-->
        <!--            :name="name"-->
        <!--            :placeholder="placeholder"-->
        <!--            :multiple="conf.multiple"-->
        <!--            :clearable="conf.clearable"-->
        <!--            :searchable="conf.searchable"-->
        <!--            :disabled="conf.disabled"-->
        <!--            :open-direction="conf.openDirection"-->
        <!--            :open-on-click="conf.openOnClick"-->
        <!--            :open-on-focus="conf.openOnFocus"-->
        <!--            :clear-on-select="conf.clearOnSelect"-->
        <!--            :close-on-select="conf.closeOnSelect"-->
        <!--            :always-open="conf.alwaysOpen"-->
        <!--            :append-to-body="conf.appendToBody"-->
        <!--            :options="options"-->
        <!--            :limit="conf.limit"-->
        <!--            :max-height="conf.maxHeight"-->
        <!--            :value="value"-->
        <!--            @input="emitSelectValue"-->
        <!--            :normalizer="normalizer"-->
        <!--        />-->
        <div v-else-if="type==='check'" class="" >
          <div class=""> 
            <input type="checkbox" :checked="value" @input="emitValue($event.target.checked)" class="form-check-input" >
            <label for="" class=""></label>
          </div>
        </div>
        <select2
            v-else-if="type==='user_select' && config"
            ref="userSelector"
            v-model="changedValue"
            
            :options="options"
            :template="userTemplate"
            :selection-template="userSelectionTemplate"
            :config="{
              ...config,
              ajax: config.internal ? undefined : {
                paginated: true,
                url: genUrl('users', null,  'search'),
                term: 'query',
              }
            }"
        />
        <!--        <user-selector v-else-if="type==='user_select'" :title="userSelectTitle" v-model="changedValue"/>-->
        <div v-else-if="type==='date'" class="">
          <datepicker v-model="changedValue"
                      :clear-button="true"
                      :typeable="true"
                      :inline="false"
                      :calendar-class="calenderClass"
                      input-class=""
          />
        </div>
        <div v-else-if="type==='textarea'" class="">
          <textarea
            ref="textinput"
            class=""
            :id="name"
            :value="value"
            @input="emitValue($event.target.value)"
            @keyup.esc="closeEdit"
            :disabled="disabled"
          ></textarea>
        </div>
        <input
            v-else
            ref="ebinput"
            :type="type"
            class="w-100"
            style="
                  height:18px; border:solid 1px lightgrey; 
                  border-radius: 2px;
                  "
            :id="name"
            :value="value"
            @input="emitValue($event.target.value)"
            @keyup.enter="doUpdate"
            @keyup.esc="closeEdit"
            :disabled="disabled"
            
        />
        <div class="dm-treeselect-btn d-flex">
          <div class="editable-wrapper-input-buttons">
            <div class="editable-wrapper-input-buttons-wrap btn-group">
              <button type="button" @click="doUpdate" class="btn btn-light btn-sm shadow-lg p-2 me-1">
                <span class="svg-icon svg-icon-primary "><!--begin::Svg Icon | path:/var/www/preview.keenthemes.com/metronic/releases/2021-05-14-112058/theme/html/demo8/dist/../src/media/svg/icons/Navigation/Check.svg--><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                          <polygon points="0 0 24 0 24 24 0 24"/>
                          <path d="M6.26193932,17.6476484 C5.90425297,18.0684559 5.27315905,18.1196257 4.85235158,17.7619393 C4.43154411,17.404253 4.38037434,16.773159 4.73806068,16.3523516 L13.2380607,6.35235158 C13.6013618,5.92493855 14.2451015,5.87991302 14.6643638,6.25259068 L19.1643638,10.2525907 C19.5771466,10.6195087 19.6143273,11.2515811 19.2474093,11.6643638 C18.8804913,12.0771466 18.2484189,12.1143273 17.8356362,11.7474093 L14.0997854,8.42665306 L6.26193932,17.6476484 Z" fill="#000000" fill-rule="nonzero" transform="translate(11.999995, 12.000002) rotate(-180.000000) translate(-11.999995, -12.000002) "/>
                      </g>
                  </svg><!--end::Svg Icon--></span>
              </button>
              <button type="button" @click="closeEdit" class="btn btn-light btn-sm shadow-lg p-2">
                <span class="svg-icon svg-icon-primary"><!--begin::Svg Icon | path:/var/www/preview.keenthemes.com/metronic/releases/2021-05-14-112058/theme/html/demo8/dist/../src/media/svg/icons/Navigation/Close.svg--><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                          <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                              <rect x="0" y="7" width="16" height="2" rx="1"/>
                              <rect opacity="0.7" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000) " x="0" y="7" width="16" height="2" rx="1"/>
                          </g>
                      </g>
                  </svg><!--end::Svg Icon--></span>
              
              </button>

            </div>
          </div>

        </div>
      </div>
    </div>
  </span>
</template>
<!--@blur="edit = false"-->

<script>
import UserSelector from "@cc/includes/UserSelector.vue";

const config = {
  multiple: false,
  clearable: true,
  searchable: true,
  disabled: false,
  openDirection: 'top',
  openOnClick: true,
  openOnFocus: false,
  clearOnSelect: false,
  closeOnSelect: true,
  alwaysOpen: false,
  appendToBody: false,
  limit: 10,
  maxHeight: 200,

  id: 'id',
  label: 'label',
}

export default {
  components: {UserSelector},
  props: {
    type: {
      default: "text"
    },
    editable: {
      default: true,
    },
    value: {
      type: String | Number,
      default: '',
      required: false,
    },
    placeholder: {
      type: String | Number,
      default: 'Select One'
    },
    name: {
      type: String | Number,
      required: false,
    },
    label: {
      type: String | Number,
      required: false,
    },
    context: {
      default: null,
    },
    update: {
      default() {
      }
    },
    disabled: {
      default: false,
    },
    config: {
      type: Object,
      default: null,
    },
    options: {
      type: Array,
      default: () => [],
    },
    userSelectTitle: {
      type: String,
      default: ""
    },
    placement: {
      type: String,
      default: "bottom-end"
    },
    calendarPlacement: {
      type: String | Array,
      default: "top"
    },
  },
  data() {
    return {
      edit: false,
      selectVal: null,
      // selectTick: 0,
      changedValue: undefined,
      // absClasses: "card m-1 p-2 position-absolute z-index-9",
      rkey: _.random(true),
      ktm: null,
      hovered: false,
      listeners: false,
    }
  },
  computed: {
    conf() {
      if (!this.config) return {...config};

      return {...config, ...this.config}
    },
    calenderClass() {
      let classes = []
      if (Array.isArray(this.calendarPlacement)) {
        classes = this.calendarPlacement
      } else {
        classes = [this.calendarPlacement]
      }

      let finalized = []
      classes.forEach(cls => {
        let class_ = ''
        switch (cls) {
          case 'top':
            class_ = 'bottom-8'
            break
          case 'bottom':
            class_ = 'top-0'
            break
          case 'left':
            class_ = 'end-0'
            break
          case 'right':
            class_ = 'start-0'
            break
          default:
            class_ = cls
        }
        finalized.push(class_)
      })

      return finalized
    }
  },
  watch: {
    value: {
      handler(val) {
        this.changedValue = val
      }
    }
  },
  created() {
    if (this.type === 'user_select') {
      this.changedValue = this.value || []
    }
    if (this.type === 'date') {
      this.changedValue = this.value || ''
    }
  },
  mounted() {
    // this.docu = document.addEventListener('click', (elem) => {
    //   console.log(elem, this.$el.contains(elem.target))
    //   // detects if the click is within this.$el
    //   if(!this.$el.contains(elem.target)){
    //     this.closeEdit()
    //   }
    // })
  },
  destroyed() {
    // this.killKTM()
    // this.docu = null
  },
  methods: {
    closeEdit() {
      this.edit = false
      // this.ktm.hide()
    },
    killKTM() {
      // if (this.ktm) {
      //   this.ktm.off("kt.menu.dropdown.shown")
      //   this.ktm.off("kt.menu.dropdown.hide")
      //   this.ktm.destroy()
      // }
    },
    mkHovered(){
      if(!this.editable) return;
      this.hovered = true

      // this.ktm = KTMenu.getInstance(this.$refs.popContent)
      // this.$nextTick(() => {
      // })
    },
    mkEditable() {
      if(!this.editable) return;

      this.rkey = _.random(true)
      this.edit = true
      // this.killKTM()
      // if (this.ktm) return

      // if(this.listeners) return;

      this.$nextTick(() => {
        if (this.type === 'text') {
          this.$refs.ebinput.focus()
        }
        if (this.type === 'textarea') {
          this.$refs.textinput.focus()
        }
        if (this.type === 'select') {
          this.$refs.selector.focus()
        }
        if (this.type === 'user_select') {
          this.$refs.userSelector.focus()
        }
      })

      this.listeners = true
      //render ktMenu instance on hover
      this.$nextTick(() => {
      })
      setTimeout(() => {
        // window.KTMenu.createInstances()
        // this.ktm.show()
        // this.ktm.show()
        // setTimeout(() => this.ktm.show(), 1000)
      }, 100)

    },
    emitValue(value) {
      this.changedValue = value
      return
      this.$emit('input', value)
    },
    emitSelectValue(value) {
      // console.log('ems', value)
      // this.selectTick++
      const val_ = value === undefined ? null : value;
      this.changedValue = val_
      // if(this.selectTick < 2) return;
      return
      this.$emit('input', val_)
      this.doUpdate(val_)
    },
    normalizer(node) {
      return {
        id: node[this.conf.id],
        label: node[this.conf.label],
      }
    },
    doUpdate: async function () {
      let updateValue = typeof this.changedValue === 'undefined' ? this.value : this.changedValue
      console.log(updateValue)
      try {
        await this.update(this.name, updateValue, this.context)
        this.closeEdit()
      } catch (e) {
        throw e
      }
    },
    dateOpened() {
      // setTimeout(() => {
      //    KTMenu.updateDropdowns()
      //    this.ktm.update()
      //  }, 3000)
    },
    dateClosed() {
      // console.log(`xaxa`)
    },
  },
}
</script>